import styled from "styled-components";
import { toAbsoluteUrl } from "../../utils/assetHelper";

export const Header = styled.div`
margin-top: 20px;
h1{
    font-size: 48px;
    font-weight: 800;
    margin-bottom: 16px;
    text-align: center;
    color: #fff;

    span{
        color: var(--primary-color);
    }
    
    @media screen and (max-width: 1100px) {
        font-size: 36px;
    }
}
`

export const Wrapper = styled.div`
background: url(${toAbsoluteUrl('/media/productreleasebg.jpg')}) no-repeat;
background-size: 100% 100%;
`

export const Content = styled.div`
width: 95vw;
margin: 60px auto 0;
padding-bottom: 32px;
display: flex;
flex-direction: column;
gap: 24px;
`

export const CardContainer = styled.div`
background: ${props => props.background ? props.background : props.gradientBg ? 'linear-gradient(102deg, rgba(63, 27, 208, 0.05) 4.47%, rgba(215, 76, 16, 0.05) 54.56%)' : "#F4F4F4"};
color: ${props => props.textColor || "#1E1E1E"};
display: flex;
flex-direction: column;
justify-content: ${props => props.justifyContent || "center"};
align-items: ${props => props.alignItems || "center"};
padding: ${props => props.padding || "24px"};
border-radius: ${props => props.radius || "20px"};
width: ${props => props.width || "100%"};
gap: ${props => props.gap || 0};
margin: 0 auto;

@media screen and (max-width: 1100px) {
    padding: 16px;
    width: 100%;
}

h2 {
    font-size: 32px;
    font-weight: 700;
    line-height: 45px;
    text-align: ${props => props.textAlignH2 || "left"};
    margin-bottom: ${props => props.mb_h2 || "0"};
    color: ${props => props.color || "#1E1E1E"};
    width: 100%;

    @media screen and (max-width: 1100px) {
        font-size: 24px; 
    }
}

h3 {
font-size: 24px;
font-weight: 700;
line-height: 28px;
text-align: ${props => props.textAlignH3 || "center"};
margin-bottom: ${props => props.mb_h3 || "0"};

@media screen and (max-width: 1100px) {
    font-size: 20px;
}
}

p {
font-weight: 400;
font-size: ${props => props.fontSizeP || "18px"};
line-height: 28px;
text-align: ${props => props.textAlignP || "center"};
margin: 0 auto;
margin-bottom: ${props => props.mb_p || "0"};
width: ${props => props.widthP || "100%"};

@media screen and (max-width: 1100px) {
    width: 100%;
}
}

img {
    width: ${props => props.imgWidth || "300px"};
    object-fit: cover;
    height: ${props => props.imgHeight || "auto"};
    border-radius: 10px;
}

.bulk-btn {
    align-self: flex-start;

    @media screen and (max-width: 1100px) {
        align-self: center;
    }

}

.product{
    width: 100%;
    display: grid;
    grid-template-columns: 1fr auto;
    background: #fff;
    border-radius: 16px;
    padding: 16px;
    gap: 16px;
    align-items: center;

    @media screen and (max-width: 1100px) {
        grid-template-columns: 1fr;
    }

.product-details {
    display: grid;
    grid-template-columns: auto 1fr auto;
    gap: 32px;
    align-items: center;

    @media screen and (max-width: 1100px) {
        grid-template-columns: 1fr;
        gap: 8px;
    }

    h4 {
        font-size: 18px;
        font-weight: 500;
        line-height: 28px;

    @media screen and (max-width: 1100px) {
        text-align: center;
    }
    }
}


.btn-container {
    display: flex;
    gap: 8px;
    align-items: center;
    width: max-content;

.view-btn {
    color: #3f1bd0 !important;
}

.add-btn {
    display: flex;
    gap: 5px;
    align-items: center;
}

@media screen and (max-width: 1100px) {
        width: 100%;
        justify-content: center;
    }
}
}
`

